import { render, staticRenderFns } from "./MiddleMenu.vue?vue&type=template&id=e0bf34c6&scoped=true"
import script from "./MiddleMenu.vue?vue&type=script&lang=js"
export * from "./MiddleMenu.vue?vue&type=script&lang=js"
import style0 from "./MiddleMenu.vue?vue&type=style&index=0&id=e0bf34c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0bf34c6",
  null
  
)

export default component.exports